/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// BODYCOPY : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	bodycopy: {
		color: theme.color.supporting.dark.swatch,
		margin: '0 auto',
		position: 'relative',
		// maxWidth: pxToEm(650),
		
		// elements
		'& p, ul, ol': { 
			extend: theme.typography.size.small,
			marginBottom: pxToRem(20)
		},
		'& ul, ol': { 
			paddingLeft: pxToEm(30) 
		},

		// generates classes for every size in the theme ".size-(uniqueColor)"
		extend: themeStyleHelper(theme.typography, 'size', (theme, uniqueProp) => {
			return {
				'& p, ul, ol': { 
					extend: theme.size[uniqueProp]
				}
			}
		}),
	}
});